var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1CityCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.08 40.65c-2-1.71-18.09-11.47-21.06-13C37.35 25.81 34 24 28.86 24a19.254 19.254 0 00-6.17.94A12.42 12.42 0 0018 27.59a18.913 18.913 0 00-2.95 3.89l-.43.72C13.38 34.4 10 40.28 10 41v7a6 6 0 005 5.91v-.09a7 7 0 1114 0V54h18.11v-.18a7 7 0 1114 0V54h2.15s2.1-5.79 2.07-8c-.05-2-1.26-3.65-3.25-5.35zM28 37.06L24 34h-5.53c.1-.27 2.54-6 10-6 8.25-.08 24.23 11.37 25 11.91L28 37.06zm30.1 16.76V54a4 4 0 11-8 0 1.104 1.104 0 010-.18 4 4 0 018 0zm-32 0V54a4 4 0 11-8 0v-.18a4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_City_car.21c7f99e.svg";
export { SvgI1CityCar as ReactComponent };